export class SearchHelpers {
  static getBirthYearString(
    birthYear: string,
    age: string,
    operator: string
  ): string {
    const yearPrefix = operator === "lt" ? "<" : operator === "gte" ? ">" : "";
    return birthYear || age ? yearPrefix + (birthYear ? birthYear : age) : "";
  }

  static parseBirthYearString(birthYear: string): {
    value: string;
    operator: string;
  } {
    const opPrefix = birthYear.slice(0, 1);
    const operator =
      opPrefix === "<" ? "lt" : opPrefix === ">" ? "gte" : "exact";
    const birthYearResult =
      operator !== "exact" ? birthYear.slice(1) : birthYear;
    return { value: birthYearResult, operator };
  }

  static getSigExpressionString(
    sigId: string,
    operator: string,
    rating: string
  ): string {
    return sigId + operator + rating;
  }

  static parseSigExpressionString(sigExpression: string): {
    sigId: string;
    operator: string;
    rating: string;
  } {
    if (!sigExpression) return { sigId: "", operator: "", rating: "" };
    const found = sigExpression.match(/(\d+)([lgte]+)(\d+)/);
    const [sigId, operator, rating] = found ? found.slice(1) : [];
    return { sigId, operator, rating };
  }
}
